export default __webpack_public_path__ + "static/media/quoridor.a06e5447.png";